import moment from "moment-timezone"
import 'moment/locale/th';
moment.locale('th')
moment().tz("Asia/Bangkok").format();

export default moment